module.exports = __webpack_public_path__ + "static/media/splashScreenImage.5e3256e2.png";